import {Component, OnDestroy, OnInit} from '@angular/core';
import {GenericDatatableComponent} from '../generic-datatable/generic-datatable.component';
import {select} from '@ngrx/store';
import * as fromRoot from '../../reducers';
import {SetPreferencesAction} from '../../actions/preferences';
import {OrderItem} from '../../../order/models/order-item';
import {
  ChangeInvoicesPageSizeAction,
  ClearInvoicesAction,
  LoadInvoicesAction,
  OrderInvoicesByAction,
  PageInvoicesToAction, QuickSearchInvoicesAction,
  SearchInvoicesAction, ToggleSearchInvoicesAction
} from '../../actions/invoices-list';
import * as fromSites from '../../../site/reducers';
import {CompanyClearAction} from '../../../company/actions/company-load';

@Component({
  selector: 'storever-invoices-list',
  templateUrl: '../../../shared/components/generic-datatable/generic-datatable.component.html',
  styleUrls: ['../../../shared/components/generic-datatable/generic-datatable.component.scss']
})
export class InvoicesListComponent extends GenericDatatableComponent implements OnInit, OnDestroy {

  ngOnInit(): void {
    super.ngOnInit();
    this.loadDataOnChangeUrl('date descending', 'invoices_row_size');
    // this.orderByChanged('date descending');
  }

  ngOnDestroy(): void {
    this.storeCompany.dispatch(new CompanyClearAction());
    this.storeRoot.dispatch(new ClearInvoicesAction());
    this.dataConfig.form.markAsPristine();
    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }

  loadData(): void {
    this.getRoute()
  }

  getRoute(): void {
    this.sub$ =  this.activatedRoute.params.subscribe(params => {
      if (params.contractId && this.router.url.search('contracts') !== -1) {
        this.storeRoot.dispatch(new LoadInvoicesAction({route: 'contracts' , uuid: params.contractId}));
      }
      if (params.companyId && this.router.url.search('companies') !== -1) {
        this.storeRoot.dispatch(new LoadInvoicesAction({route: 'companies' , uuid: params.companyId}));
      }
      if (params.id && this.router.url.search('sites') !== -1) {

        this.sub$ =  this.storeSite.pipe(select(fromSites.selectors.getSite)).subscribe( data => {
             if (data) {
               this.storeRoot.dispatch(new LoadInvoicesAction({route: 'sites' , uuid:  data.subscriptions[0].uuid}));
             }
          }
        )
        this.subscriptions.push(this.sub$);
      }
    });
    this.subscriptions.push(this.sub$);
  }

  storeSelect(): void {
    this.pageSize$ = this.storeRoot.pipe(select(fromRoot.selectors.getPreferencesByName, 'invoices_row_size'));
    this.count$ = this.storeContract.pipe(select(fromRoot.selectors.getInvoicesCount));
    this.showFilter$ = this.storeContract.pipe(select(fromRoot.selectors.getInvoicesShowFilter));
    this.data$ = this.storeRoot.pipe(select(fromRoot.selectors.getInvoices));
    let pageSizeInit = true ;
    this.sub$ = this.pageSize$.subscribe(pageSize => {
      if ( pageSizeInit && pageSize ) {
      this.storeContract.dispatch(new ChangeInvoicesPageSizeAction(pageSize));
      pageSizeInit = false;
      }
    });
    this.subscriptions.push(this.sub$);
  }

  orderByChanged(orderBy: string): void {
    this.storeContract.dispatch(new OrderInvoicesByAction(orderBy));
  }

  pageSizeChanged(pageSize: number): void {
    this.storeContract.dispatch(new SetPreferencesAction({ name: 'invoices_row_size', value: '' + pageSize }));
    this.storeContract.dispatch(new ChangeInvoicesPageSizeAction(pageSize));
  }

  pageChanged(page: number): void {
    this.storeContract.dispatch(new PageInvoicesToAction(page));
  }

  // tslint:disable-next-line:no-any
  applyFilter(filterForm: any): void {
    let countryCode;
    if (filterForm && filterForm.countryCode && filterForm.countryCode.code) {
      countryCode = filterForm.countryCode.code;
      filterForm.countryCode = countryCode;
    }
    this.storeContract.dispatch(new SearchInvoicesAction(this.filterDeleteIfNilService.flatten(filterForm)));
  }

  applyQuickFilter(query: string): void {
    this.storeContract.dispatch(new QuickSearchInvoicesAction(query));
  }

  toggleFilter(showFilter: boolean): void {
    this.storeContract.dispatch(new ToggleSearchInvoicesAction(!showFilter));
  }

  dispatchClearDataAction(): void {

    this.storeContract.dispatch(new ClearInvoicesAction());
  }

  dispatchToggleSelected(order: OrderItem): void {
  }

  toggleSelected(order: OrderItem): void {
  }


  disablePagination(): boolean {
    return false;
  }

  // tslint:disable-next-line:no-any
  actionButton(type: string, data?: any): void { }

  // tslint:disable-next-line:no-any
  routerLink(route: string, data: any, fragment?: string): {path: string[], fragment?: string | null} {
    if ( route === 'contractName') {
      return { path: ['/', data.companyUuid, 'contracts', 'detail', data.contractUuid], fragment: fragment };
    }
    if ( route === 'companyName') {
      return { path: ['/' , 'companies', 'detail', data.companyUuid], fragment: fragment };
    }
    if ( route === 'invoicesDetail') {
      return { path: ['/',  'invoices', 'detail', data.uuid] };
    }
  }
}

